<template>
    <div class="i-multi-select">
    	<div class="label">{{label}}</div>
        <div v-for="(i,idx) in options">
            <label>
                <input type="checkbox" :checked="checked.indexOf(i.value)!=-1" @change="onChange(i,idx)" /> {{i.label}}
                
            </label>
        </div>
    </div>
</template>
<script>
export default {

    name: 'i-multi-select',
    mounted() {
        if (Array.isArray(this.value)) {
            this.checked = this.value;
        }
    },
    methods: {
        onChange(v, idx) {
            let alreadyHave = this.checked.indexOf(v.value) != -1;
            if (event.target.checked) {
                if (!alreadyHave) this.checked.push(v.value);
            } else {
                if (alreadyHave) {
                    this.checked.splice(this.checked.indexOf(v.value), 1);
                }
            }
            console.log(this.checked)
            this.$emit('input', this.checked);
        }
    },
    props: {
        options: { type: Array, default () { return [{ value: 1, label: "One" }, { value: 2, label: "Two" }, { value: 3, label: "Three" }] } },
        label:String,
        value: Array

    },
    data() {
        return {
            checked: []
        }
    }
}
</script>
<style lang="css" scoped>
.i-multi-select {
	display: inline-block;
    border-radius: 4px;
    padding: 4px;
    border:1px solid lightgrey;
    margin:2px;
}
</style>